/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import CustomAddActionCard from '../../../../common/components/CustomAddActionCard/CustomAddActionCard';
import { Box, Grid, Typography } from '@mui/material';
import LeaveAppliedContent from '../../../../common/components/LeaveAppliedContent/LeaveAppliedContent';
import ApplyLeaveModalController from '../../../../common/Modals/Leaves/ApplyLeave/ApplyLeaveModalController';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import _ from 'lodash';
import { fonts, themes } from '../../../../common/themes/themes';
import LeaveAppliedViewModalController from '../../../../common/Modals/Leaves/LeaveAppliedViewModal/LeaveAppliedViewModalController';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import {
  baseDateFormatting,
  LEAVE_ADVANCE,
  LEAVE_ENCASHMENT,
} from '../../../../common/helper';
import moment from 'moment';
import CancelLeaveModal from '../../../../common/Modals/Leaves/CancelLeaveModal/CancelLeaveModal';
import { leavesService } from '../../../../api/services/leavesService';
import Warning from '../../../../common/Modals/WarningModal/Warning';
import award from '../../../../common/components/ActionRequiredTables/Award';
import {
  setAllLeaveApplied,
  setRefreshLeaveApplied,
} from '../../../../infra/aggregates/myProfile/leavesAggregates/leaveAppliedSlice';
import {
  setAllLeaveHistory,
  setRefreshLeaveHistory,
} from '../../../../infra/aggregates/myProfile/leavesAggregates/leaveHistorySlice';
import {
  resetLeaveEligibility,
  setLeaveEligibility,
  setRefreshLeaveEligibility,
} from '../../../../infra/aggregates/myProfile/leavesAggregates/leaveEligibilitySlice';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import toast from 'react-hot-toast';

interface propsType {
  leaveData: any;
  isLoading?: boolean;
  trans?: any;
  i18n?: any;
  setTypeFilter: (data: string) => void;
}

const EmergencyContactPresenter: React.FC<propsType> = ({
  leaveData,
  isLoading,
  trans,
  i18n,
  setTypeFilter,
}) => {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state);

  const [openModal, setOpenModal] = useState(false);
  const [leaveAppliedViewData, setLeaveAppliedViewData] = useState({});
  const [openApplyLeaveModal, setOpenApplyLeaveModal] = useState(false);
  const [leaveType, setleaveType] = useState('Leaves');
  const [openCancelModel, setOpenCancelModel] = useState<boolean>(false);
  const [leaveCancelPayload, setLeaveCancelPayload] = useState<any>({});
  const [payedLeaveCancelPayload, setPayedLeaveCancelPayload] = useState<any>(
    {},
  );
  const [cancelLeaveWarning, setCancelLeaveWarning] = useState<boolean>(false);

  const handleSelecttype = (type: any) => {
    setleaveType(type?.id);
    setTypeFilter(type?.id);
  };

  const refreshFunction = async () => {
    const response = await leavesService.getEmployeeAppliedLeaves(
      selector.authSlice.company_id,
      selector.authSlice.emp_id,
    );
    if (response) {
      dispatch(setAllLeaveApplied(response.data));
    }
    dispatch(setRefreshLeaveApplied(false));

    dispatch(setRefreshLeaveHistory(true));
    const response_history = await leavesService.getEmployeeLeaveHistory(
      selector.authSlice.company_id,
      selector.authSlice.emp_id,
    );
    if (response) {
      dispatch(setAllLeaveHistory(response_history.data));
    }
    dispatch(setRefreshLeaveHistory(false));

    setleaveType('Leaves');
    setTypeFilter('Leaves');
  };

  const handleCancel = async (leave: any) => {
    const payload = {
      leave_id: leave.id,
      company_id: leave.company_id,
      emp_id: leave.emp_id,
      leave_type: leave.leave_type_id,
    };
    setPayedLeaveCancelPayload(payload);
    setLeaveCancelPayload({
      ...payload,
      cancel_whole_leave: true,
      from_date: leave.start_date,
      to_date: leave.end_date,
    });
    setCancelLeaveWarning(true);
  };
  const onConfirmCancel = async () => {
    if (leaveType === LEAVE_ADVANCE) {
      await handleCancelLeaveAdvance();
      return;
    }
    if (leaveType === LEAVE_ENCASHMENT) {
      await handleCancelLeaveEncashment();
      return;
    }
    setOpenCancelModel(true);
    setCancelLeaveWarning(false);
  };
  const handleCancelLeaveAdvance = async () => {
    await leavesService
      .cancelLeaveAdvance(payedLeaveCancelPayload)
      .then((res) => {
        setCancelLeaveWarning(false);
        refreshFunction();
      });
  };

  const handleCancelLeaveEncashment = async () => {
    await leavesService
      .cancelLeaveEncashment(payedLeaveCancelPayload)
      .then((res) => {
        setCancelLeaveWarning(false);
        refreshFunction();
      });
  };
  const handleSendRemainder = async (leave: any) => {
    const payload = {
      instanceId: leave?.workflow_instance_id,
      empId: leave?.emp_id,
    };
    await leavesService
      .sendRemanider(leave?.workflow_instance_id, leave?.emp_id)
      .then((res) => {
        toast.success(trans(res?.data));
      })
      .catch((err) => {
        toast.error(err?.error?.data);
      });
  };

  return (
    <>
      <CustomAddActionCard
        card_title={trans('Applied')}
        card_height="320px"
        height="320px"
        onClick={() => setOpenApplyLeaveModal(true)}
        card_subtitle={`${trans('Total')} : ${leaveData?.length}`}
        showtypefilter={true}
        onfilterhead={handleSelecttype}
        leaveType={leaveType}
      >
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <>
            {leaveData.length > 0 ? (
              _.map(leaveData, (leave: any, i) => {
                return (
                  <div key={i}>
                    <Box style={{ marginBottom: '24px' }} />
                    <LeaveAppliedContent
                      leaveName={leave?.leave_type?.name}
                      endDate={moment(leave?.end_date).format(
                        baseDateFormatting,
                      )}
                      startDate={moment(leave?.start_date).format(
                        baseDateFormatting,
                      )}
                      totalLeaveDays={leave?.total_leave_days}
                      status={leave?.status}
                      encashtype={leave?.encashment_type}
                      payment_type={leave?.payment_type}
                      amount={leave?.amount}
                      onClick={() => {
                        setOpenModal(true);
                        setLeaveAppliedViewData(leave);
                      }}
                      onLeaveCancel={async () => {
                        await handleCancel(leave);
                      }}
                      onSendremaninder={() => handleSendRemainder(leave)}
                    />
                  </div>
                );
              })
            ) : (
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <img src={emptyIcon} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Not Applied')}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.subtitle,
                      color: themes.defaultIcon,
                    }}
                  >
                    {trans('Currently you haven’t any leave Applications')}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </>
        )}
      </CustomAddActionCard>

      {/* LeaveApplied View Modal */}

      {openApplyLeaveModal && (
        <ApplyLeaveModalController
          isModalOpen={openApplyLeaveModal}
          closeModal={() => setOpenApplyLeaveModal(false)}
          trans={trans}
          i18n={i18n}
        />
      )}
      {/* LeaveApplied View Modal */}

      {openModal && (
        <LeaveAppliedViewModalController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
          leaveAppliedViewData={leaveAppliedViewData}
          trans={trans}
        />
      )}
      {openCancelModel && (
        <CancelLeaveModal
          isModalOpen={openCancelModel}
          leaveCancelData={leaveCancelPayload}
          closeModal={() => setOpenCancelModel(false)}
          trans={trans}
        />
      )}
      {cancelLeaveWarning && (
        <Warning
          openmodal={cancelLeaveWarning}
          infoMessage={trans('Do you want to cancel this leave')}
          onconfirm={() => onConfirmCancel()}
          oncancel={() => setCancelLeaveWarning(false)}
        />
      )}
    </>
  );
};

export default EmergencyContactPresenter;
